/**
 * RedirectLocaleRoute: Handle routing to a page based on the locale. Matches
 * on locale and redirects to specified URL.
 *
 * Right now, this only handles and should only be used for external redirects.
 * If the use-case of handling internal redirects comes up, this will need
 * to be modified to handle that.
 */
import * as React from "react";
import {Route} from "react-router-dom";

import {RequestInfo} from "@khan/shared-core";

import SmartRedirect from "#shared/app-shell/smart-redirect.tsx";

import AsyncRouteHandler from "./async-route-handler.tsx";
import type {CommonRouteProps} from "./types.ts";

type Props = CommonRouteProps & {
    // An object that has a key that matches a locale and a value that matches
    // an external URL.
    // ex: { 'en': 'http://www.google.com' }
    redirects: Record<string, string>;
};

type DefaultProps = {
    redirects: Props["redirects"];
};

export default class RedirectLocaleRoute extends React.Component<Props> {
    static defaultProps: DefaultProps = {
        redirects: {},
    };

    render(): React.ReactNode {
        const {exact, redirects, path, component} = this.props;

        if (RequestInfo.kaLocale in redirects) {
            return (
                <SmartRedirect
                    from={path}
                    to={redirects[RequestInfo.kaLocale]}
                    forceFullPageLoad={true}
                    exact={exact}
                />
            );
        }

        return (
            <Route
                path={path}
                render={() => (
                    <AsyncRouteHandler
                        component={component}
                        template={this.props.template}
                    />
                )}
            />
        );
    }
}
